// extracted by mini-css-extract-plugin
module.exports = {"image":"ModalContent_image__2yHVI","modalContent":"ModalContent_modalContent__2Ret1","closeIcon":"ModalContent_closeIcon__3owH9"};